import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ManagerProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const role = useSelector((state) => state.user.role);

  if (!isAuthenticated || role !== "sales-manager") {
    return <Navigate to="/" />;
  }

  return children;
};

export default ManagerProtectedRoute;
